/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BaseOption } from './BaseOption';
import {
    BaseOptionFromJSON,
    BaseOptionFromJSONTyped,
    BaseOptionToJSON,
} from './BaseOption';
import type { Category } from './Category';
import {
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
} from './Category';
import type { Classification } from './Classification';
import {
    ClassificationFromJSON,
    ClassificationFromJSONTyped,
    ClassificationToJSON,
} from './Classification';
import type { FutureStock } from './FutureStock';
import {
    FutureStockFromJSON,
    FutureStockFromJSONTyped,
    FutureStockToJSON,
} from './FutureStock';
import type { Image } from './Image';
import {
    ImageFromJSON,
    ImageFromJSONTyped,
    ImageToJSON,
} from './Image';
import type { MediqClassification } from './MediqClassification';
import {
    MediqClassificationFromJSON,
    MediqClassificationFromJSONTyped,
    MediqClassificationToJSON,
} from './MediqClassification';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { PriceRange } from './PriceRange';
import {
    PriceRangeFromJSON,
    PriceRangeFromJSONTyped,
    PriceRangeToJSON,
} from './PriceRange';
import type { ProductDocument } from './ProductDocument';
import {
    ProductDocumentFromJSON,
    ProductDocumentFromJSONTyped,
    ProductDocumentToJSON,
} from './ProductDocument';
import type { ProductNonInventoryPart } from './ProductNonInventoryPart';
import {
    ProductNonInventoryPartFromJSON,
    ProductNonInventoryPartFromJSONTyped,
    ProductNonInventoryPartToJSON,
} from './ProductNonInventoryPart';
import type { ProductReference } from './ProductReference';
import {
    ProductReferenceFromJSON,
    ProductReferenceFromJSONTyped,
    ProductReferenceToJSON,
} from './ProductReference';
import type { Promotion } from './Promotion';
import {
    PromotionFromJSON,
    PromotionFromJSONTyped,
    PromotionToJSON,
} from './Promotion';
import type { Review } from './Review';
import {
    ReviewFromJSON,
    ReviewFromJSONTyped,
    ReviewToJSON,
} from './Review';
import type { SAPUnit } from './SAPUnit';
import {
    SAPUnitFromJSON,
    SAPUnitFromJSONTyped,
    SAPUnitToJSON,
} from './SAPUnit';
import type { SalesUnits } from './SalesUnits';
import {
    SalesUnitsFromJSON,
    SalesUnitsFromJSONTyped,
    SalesUnitsToJSON,
} from './SalesUnits';
import type { Stock } from './Stock';
import {
    StockFromJSON,
    StockFromJSONTyped,
    StockToJSON,
} from './Stock';
import type { VariantMatrixElement } from './VariantMatrixElement';
import {
    VariantMatrixElementFromJSON,
    VariantMatrixElementFromJSONTyped,
    VariantMatrixElementToJSON,
} from './VariantMatrixElement';
import type { VariantOption } from './VariantOption';
import {
    VariantOptionFromJSON,
    VariantOptionFromJSONTyped,
    VariantOptionToJSON,
} from './VariantOption';

/**
 * Representation of a Product
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * Code of the product
     * @type {string}
     * @memberof Product
     */
    code?: string;
    /**
     * Name of the product
     * @type {string}
     * @memberof Product
     */
    name?: string;
    /**
     * Url address of the product
     * @type {string}
     * @memberof Product
     */
    url?: string;
    /**
     * Description of the product
     * @type {string}
     * @memberof Product
     */
    description?: string;
    /**
     * Flag defining if product is purchasable
     * @type {boolean}
     * @memberof Product
     */
    purchasable?: boolean;
    /**
     * 
     * @type {Stock}
     * @memberof Product
     */
    stock?: Stock;
    /**
     * List of future stocks
     * @type {Array<FutureStock>}
     * @memberof Product
     */
    futureStocks?: Array<FutureStock>;
    /**
     * Flag defining if product is available for pickup
     * @type {boolean}
     * @memberof Product
     */
    availableForPickup?: boolean;
    /**
     * Rating number of average value
     * @type {number}
     * @memberof Product
     */
    averageRating?: number;
    /**
     * Number of reviews associated with the product
     * @type {number}
     * @memberof Product
     */
    numberOfReviews?: number;
    /**
     * Product summary
     * @type {string}
     * @memberof Product
     */
    summary?: string;
    /**
     * Data of product manufacturer
     * @type {string}
     * @memberof Product
     */
    manufacturer?: string;
    /**
     * Variant type of the product
     * @type {string}
     * @memberof Product
     */
    variantType?: string;
    /**
     * 
     * @type {Price}
     * @memberof Product
     */
    price?: Price;
    /**
     * 
     * @type {SAPUnit}
     * @memberof Product
     */
    sapUnit?: SAPUnit;
    /**
     * Information about base product
     * @type {string}
     * @memberof Product
     */
    baseProduct?: string;
    /**
     * List of images linked to product
     * @type {Array<Image>}
     * @memberof Product
     */
    images?: Array<Image>;
    /**
     * List of categories product belongs to
     * @type {Array<Category>}
     * @memberof Product
     */
    categories?: Array<Category>;
    /**
     * List of reviews associated with the product
     * @type {Array<Review>}
     * @memberof Product
     */
    reviews?: Array<Review>;
    /**
     * List of classifications related to the product
     * @type {Array<Classification>}
     * @memberof Product
     */
    classifications?: Array<Classification>;
    /**
     * List of potential promotions related to the product
     * @type {Array<Promotion>}
     * @memberof Product
     */
    potentialPromotions?: Array<Promotion>;
    /**
     * List of variant options related to the product
     * @type {Array<VariantOption>}
     * @memberof Product
     */
    variantOptions?: Array<VariantOption>;
    /**
     * List of base options related to the product
     * @type {Array<BaseOption>}
     * @memberof Product
     */
    baseOptions?: Array<BaseOption>;
    /**
     * Flag stating if volume price should be displayed
     * @type {boolean}
     * @memberof Product
     */
    volumePricesFlag?: boolean;
    /**
     * List of volume prices
     * @type {Array<Price>}
     * @memberof Product
     */
    volumePrices?: Array<Price>;
    /**
     * List of product references
     * @type {Array<ProductReference>}
     * @memberof Product
     */
    productReferences?: Array<ProductReference>;
    /**
     * List of variant matrixes associated with the product
     * @type {Array<VariantMatrixElement>}
     * @memberof Product
     */
    variantMatrix?: Array<VariantMatrixElement>;
    /**
     * 
     * @type {PriceRange}
     * @memberof Product
     */
    priceRange?: PriceRange;
    /**
     * Flag stating if product is multidimensional
     * @type {boolean}
     * @memberof Product
     */
    multidimensional?: boolean;
    /**
     * Configurator type related to the product
     * @type {string}
     * @memberof Product
     */
    configuratorType?: string;
    /**
     * Flag stating if product is configurable
     * @type {boolean}
     * @memberof Product
     */
    configurable?: boolean;
    /**
     * Tags associated with the product
     * @type {Set<string>}
     * @memberof Product
     */
    tags?: Set<string>;
    /**
     * Flag specifies whether product can be added to cart. When addToCartDisabled=true, the product is not allowed to be added into cart and the reason is explained through sapAddToCartDisabledMessage; when addToCartDisabled=false, the product is allowed to be added into cart.
     * @type {boolean}
     * @memberof Product
     */
    sapAddToCartDisabled?: boolean;
    /**
     * Message shows why product can not be added to cart.
     * @type {string}
     * @memberof Product
     */
    sapAddToCartDisabledMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    firstVariantCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    firstVariantImage?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    productType?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    packagingDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    sizeDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    size?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    packageQuantity?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    packageUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    packageSalesUnit?: string;
    /**
     * 
     * @type {Price}
     * @memberof Product
     */
    basePrice?: Price;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    appropriated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    contracted?: boolean;
    /**
     * 
     * @type {SalesUnits}
     * @memberof Product
     */
    salesUnits?: SalesUnits;
    /**
     * 
     * @type {Array<ProductDocument>}
     * @memberof Product
     */
    documents?: Array<ProductDocument>;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    supplierAlternativeAID?: string;
    /**
     * 
     * @type {Price}
     * @memberof Product
     */
    discountedPrice?: Price;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    volumeDiscountsFlag?: boolean;
    /**
     * 
     * @type {Array<Price>}
     * @memberof Product
     */
    volumeDiscounts?: Array<Price>;
    /**
     * 
     * @type {ProductDocument}
     * @memberof Product
     */
    productDatasheet?: ProductDocument;
    /**
     * 
     * @type {ProductDocument}
     * @memberof Product
     */
    technicalDatasheet?: ProductDocument;
    /**
     * 
     * @type {ProductDocument}
     * @memberof Product
     */
    safetyDatasheet?: ProductDocument;
    /**
     * 
     * @type {Array<ProductDocument>}
     * @memberof Product
     */
    brochures?: Array<ProductDocument>;
    /**
     * 
     * @type {Array<ProductDocument>}
     * @memberof Product
     */
    userManuals?: Array<ProductDocument>;
    /**
     * 
     * @type {Array<ProductDocument>}
     * @memberof Product
     */
    certificates?: Array<ProductDocument>;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    productStock?: ProductProductStockEnum;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    productWebshopStatus?: ProductProductWebshopStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    productPartStatus?: ProductProductPartStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    e6ProductId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    ceMarking?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    ceExpiryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    contentUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    ean?: string;
    /**
     * 
     * @type {Array<MediqClassification>}
     * @memberof Product
     */
    mediqClassifications?: Array<MediqClassification>;
    /**
     * 
     * @type {Array<ProductNonInventoryPart>}
     * @memberof Product
     */
    nonInventoryParts?: Array<ProductNonInventoryPart>;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    inPositiveList?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    limitPerOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    sailabCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    regulationDirective?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    regulationProductClass?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    regulationNotifiedBody?: string;
}


/**
 * @export
 */
export const ProductProductStockEnum = {
    StockRegularWithoutQuantity: 'STOCK_REGULAR_WITHOUT_QUANTITY',
    StockRegularWithQuantity: 'STOCK_REGULAR_WITH_QUANTITY',
    NonStockWithoutQuantity: 'NON_STOCK_WITHOUT_QUANTITY',
    NonStockWithQuantity: 'NON_STOCK_WITH_QUANTITY',
    NonStockDirectWithQuantity: 'NON_STOCK_DIRECT_WITH_QUANTITY',
    Unknown: 'UNKNOWN'
} as const;
export type ProductProductStockEnum = typeof ProductProductStockEnum[keyof typeof ProductProductStockEnum];

/**
 * @export
 */
export const ProductProductWebshopStatusEnum = {
    ComposableA: 'COMPOSABLE_A',
    ComposableB: 'COMPOSABLE_B',
    ComposableC: 'COMPOSABLE_C',
    ComposableD: 'COMPOSABLE_D',
    ComposableE: 'COMPOSABLE_E',
    ComposableF: 'COMPOSABLE_F',
    ComposableG: 'COMPOSABLE_G',
    No: 'NO'
} as const;
export type ProductProductWebshopStatusEnum = typeof ProductProductWebshopStatusEnum[keyof typeof ProductProductWebshopStatusEnum];

/**
 * @export
 */
export const ProductProductPartStatusEnum = {
    A: 'A',
    O: 'O',
    P: 'P',
    D: 'D',
    S: 'S',
    T: 'T',
    N: 'N',
    Unknown: 'UNKNOWN'
} as const;
export type ProductProductPartStatusEnum = typeof ProductProductPartStatusEnum[keyof typeof ProductProductPartStatusEnum];


/**
 * Check if a given object implements the Product interface.
 */
export function instanceOfProduct(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductFromJSON(json: any): Product {
    return ProductFromJSONTyped(json, false);
}

export function ProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): Product {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'purchasable': !exists(json, 'purchasable') ? undefined : json['purchasable'],
        'stock': !exists(json, 'stock') ? undefined : StockFromJSON(json['stock']),
        'futureStocks': !exists(json, 'futureStocks') ? undefined : ((json['futureStocks'] as Array<any>).map(FutureStockFromJSON)),
        'availableForPickup': !exists(json, 'availableForPickup') ? undefined : json['availableForPickup'],
        'averageRating': !exists(json, 'averageRating') ? undefined : json['averageRating'],
        'numberOfReviews': !exists(json, 'numberOfReviews') ? undefined : json['numberOfReviews'],
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
        'manufacturer': !exists(json, 'manufacturer') ? undefined : json['manufacturer'],
        'variantType': !exists(json, 'variantType') ? undefined : json['variantType'],
        'price': !exists(json, 'price') ? undefined : PriceFromJSON(json['price']),
        'sapUnit': !exists(json, 'sapUnit') ? undefined : SAPUnitFromJSON(json['sapUnit']),
        'baseProduct': !exists(json, 'baseProduct') ? undefined : json['baseProduct'],
        'images': !exists(json, 'images') ? undefined : ((json['images'] as Array<any>).map(ImageFromJSON)),
        'categories': !exists(json, 'categories') ? undefined : ((json['categories'] as Array<any>).map(CategoryFromJSON)),
        'reviews': !exists(json, 'reviews') ? undefined : ((json['reviews'] as Array<any>).map(ReviewFromJSON)),
        'classifications': !exists(json, 'classifications') ? undefined : ((json['classifications'] as Array<any>).map(ClassificationFromJSON)),
        'potentialPromotions': !exists(json, 'potentialPromotions') ? undefined : ((json['potentialPromotions'] as Array<any>).map(PromotionFromJSON)),
        'variantOptions': !exists(json, 'variantOptions') ? undefined : ((json['variantOptions'] as Array<any>).map(VariantOptionFromJSON)),
        'baseOptions': !exists(json, 'baseOptions') ? undefined : ((json['baseOptions'] as Array<any>).map(BaseOptionFromJSON)),
        'volumePricesFlag': !exists(json, 'volumePricesFlag') ? undefined : json['volumePricesFlag'],
        'volumePrices': !exists(json, 'volumePrices') ? undefined : ((json['volumePrices'] as Array<any>).map(PriceFromJSON)),
        'productReferences': !exists(json, 'productReferences') ? undefined : ((json['productReferences'] as Array<any>).map(ProductReferenceFromJSON)),
        'variantMatrix': !exists(json, 'variantMatrix') ? undefined : ((json['variantMatrix'] as Array<any>).map(VariantMatrixElementFromJSON)),
        'priceRange': !exists(json, 'priceRange') ? undefined : PriceRangeFromJSON(json['priceRange']),
        'multidimensional': !exists(json, 'multidimensional') ? undefined : json['multidimensional'],
        'configuratorType': !exists(json, 'configuratorType') ? undefined : json['configuratorType'],
        'configurable': !exists(json, 'configurable') ? undefined : json['configurable'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'sapAddToCartDisabled': !exists(json, 'sapAddToCartDisabled') ? undefined : json['sapAddToCartDisabled'],
        'sapAddToCartDisabledMessage': !exists(json, 'sapAddToCartDisabledMessage') ? undefined : json['sapAddToCartDisabledMessage'],
        'firstVariantCode': !exists(json, 'firstVariantCode') ? undefined : json['firstVariantCode'],
        'firstVariantImage': !exists(json, 'firstVariantImage') ? undefined : json['firstVariantImage'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'productType': !exists(json, 'productType') ? undefined : json['productType'],
        'packagingDescription': !exists(json, 'packagingDescription') ? undefined : json['packagingDescription'],
        'sizeDescription': !exists(json, 'sizeDescription') ? undefined : json['sizeDescription'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'packageQuantity': !exists(json, 'packageQuantity') ? undefined : json['packageQuantity'],
        'packageUnit': !exists(json, 'packageUnit') ? undefined : json['packageUnit'],
        'packageSalesUnit': !exists(json, 'packageSalesUnit') ? undefined : json['packageSalesUnit'],
        'basePrice': !exists(json, 'basePrice') ? undefined : PriceFromJSON(json['basePrice']),
        'appropriated': !exists(json, 'appropriated') ? undefined : json['appropriated'],
        'contracted': !exists(json, 'contracted') ? undefined : json['contracted'],
        'salesUnits': !exists(json, 'salesUnits') ? undefined : SalesUnitsFromJSON(json['salesUnits']),
        'documents': !exists(json, 'documents') ? undefined : ((json['documents'] as Array<any>).map(ProductDocumentFromJSON)),
        'supplierAlternativeAID': !exists(json, 'supplierAlternativeAID') ? undefined : json['supplierAlternativeAID'],
        'discountedPrice': !exists(json, 'discountedPrice') ? undefined : PriceFromJSON(json['discountedPrice']),
        'volumeDiscountsFlag': !exists(json, 'volumeDiscountsFlag') ? undefined : json['volumeDiscountsFlag'],
        'volumeDiscounts': !exists(json, 'volumeDiscounts') ? undefined : ((json['volumeDiscounts'] as Array<any>).map(PriceFromJSON)),
        'productDatasheet': !exists(json, 'productDatasheet') ? undefined : ProductDocumentFromJSON(json['productDatasheet']),
        'technicalDatasheet': !exists(json, 'technicalDatasheet') ? undefined : ProductDocumentFromJSON(json['technicalDatasheet']),
        'safetyDatasheet': !exists(json, 'safetyDatasheet') ? undefined : ProductDocumentFromJSON(json['safetyDatasheet']),
        'brochures': !exists(json, 'brochures') ? undefined : ((json['brochures'] as Array<any>).map(ProductDocumentFromJSON)),
        'userManuals': !exists(json, 'userManuals') ? undefined : ((json['userManuals'] as Array<any>).map(ProductDocumentFromJSON)),
        'certificates': !exists(json, 'certificates') ? undefined : ((json['certificates'] as Array<any>).map(ProductDocumentFromJSON)),
        'productStock': !exists(json, 'productStock') ? undefined : json['productStock'],
        'productWebshopStatus': !exists(json, 'productWebshopStatus') ? undefined : json['productWebshopStatus'],
        'productPartStatus': !exists(json, 'productPartStatus') ? undefined : json['productPartStatus'],
        'e6ProductId': !exists(json, 'e6ProductId') ? undefined : json['e6ProductId'],
        'ceMarking': !exists(json, 'ceMarking') ? undefined : json['ceMarking'],
        'ceExpiryDate': !exists(json, 'ceExpiryDate') ? undefined : json['ceExpiryDate'],
        'contentUnit': !exists(json, 'contentUnit') ? undefined : json['contentUnit'],
        'ean': !exists(json, 'ean') ? undefined : json['ean'],
        'mediqClassifications': !exists(json, 'mediqClassifications') ? undefined : ((json['mediqClassifications'] as Array<any>).map(MediqClassificationFromJSON)),
        'nonInventoryParts': !exists(json, 'nonInventoryParts') ? undefined : ((json['nonInventoryParts'] as Array<any>).map(ProductNonInventoryPartFromJSON)),
        'inPositiveList': !exists(json, 'inPositiveList') ? undefined : json['inPositiveList'],
        'limitPerOrder': !exists(json, 'limitPerOrder') ? undefined : json['limitPerOrder'],
        'sailabCode': !exists(json, 'sailabCode') ? undefined : json['sailabCode'],
        'regulationDirective': !exists(json, 'regulationDirective') ? undefined : json['regulationDirective'],
        'regulationProductClass': !exists(json, 'regulationProductClass') ? undefined : json['regulationProductClass'],
        'regulationNotifiedBody': !exists(json, 'regulationNotifiedBody') ? undefined : json['regulationNotifiedBody'],
    };
}

export function ProductToJSON(value?: Product | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'url': value.url,
        'description': value.description,
        'purchasable': value.purchasable,
        'stock': StockToJSON(value.stock),
        'futureStocks': value.futureStocks === undefined ? undefined : ((value.futureStocks as Array<any>).map(FutureStockToJSON)),
        'availableForPickup': value.availableForPickup,
        'averageRating': value.averageRating,
        'numberOfReviews': value.numberOfReviews,
        'summary': value.summary,
        'manufacturer': value.manufacturer,
        'variantType': value.variantType,
        'price': PriceToJSON(value.price),
        'sapUnit': SAPUnitToJSON(value.sapUnit),
        'baseProduct': value.baseProduct,
        'images': value.images === undefined ? undefined : ((value.images as Array<any>).map(ImageToJSON)),
        'categories': value.categories === undefined ? undefined : ((value.categories as Array<any>).map(CategoryToJSON)),
        'reviews': value.reviews === undefined ? undefined : ((value.reviews as Array<any>).map(ReviewToJSON)),
        'classifications': value.classifications === undefined ? undefined : ((value.classifications as Array<any>).map(ClassificationToJSON)),
        'potentialPromotions': value.potentialPromotions === undefined ? undefined : ((value.potentialPromotions as Array<any>).map(PromotionToJSON)),
        'variantOptions': value.variantOptions === undefined ? undefined : ((value.variantOptions as Array<any>).map(VariantOptionToJSON)),
        'baseOptions': value.baseOptions === undefined ? undefined : ((value.baseOptions as Array<any>).map(BaseOptionToJSON)),
        'volumePricesFlag': value.volumePricesFlag,
        'volumePrices': value.volumePrices === undefined ? undefined : ((value.volumePrices as Array<any>).map(PriceToJSON)),
        'productReferences': value.productReferences === undefined ? undefined : ((value.productReferences as Array<any>).map(ProductReferenceToJSON)),
        'variantMatrix': value.variantMatrix === undefined ? undefined : ((value.variantMatrix as Array<any>).map(VariantMatrixElementToJSON)),
        'priceRange': PriceRangeToJSON(value.priceRange),
        'multidimensional': value.multidimensional,
        'configuratorType': value.configuratorType,
        'configurable': value.configurable,
        'tags': value.tags === undefined ? undefined : Array.from(value.tags as Set<any>),
        'sapAddToCartDisabled': value.sapAddToCartDisabled,
        'sapAddToCartDisabledMessage': value.sapAddToCartDisabledMessage,
        'firstVariantCode': value.firstVariantCode,
        'firstVariantImage': value.firstVariantImage,
        'source': value.source,
        'productType': value.productType,
        'packagingDescription': value.packagingDescription,
        'sizeDescription': value.sizeDescription,
        'size': value.size,
        'packageQuantity': value.packageQuantity,
        'packageUnit': value.packageUnit,
        'packageSalesUnit': value.packageSalesUnit,
        'basePrice': PriceToJSON(value.basePrice),
        'appropriated': value.appropriated,
        'contracted': value.contracted,
        'salesUnits': SalesUnitsToJSON(value.salesUnits),
        'documents': value.documents === undefined ? undefined : ((value.documents as Array<any>).map(ProductDocumentToJSON)),
        'supplierAlternativeAID': value.supplierAlternativeAID,
        'discountedPrice': PriceToJSON(value.discountedPrice),
        'volumeDiscountsFlag': value.volumeDiscountsFlag,
        'volumeDiscounts': value.volumeDiscounts === undefined ? undefined : ((value.volumeDiscounts as Array<any>).map(PriceToJSON)),
        'productDatasheet': ProductDocumentToJSON(value.productDatasheet),
        'technicalDatasheet': ProductDocumentToJSON(value.technicalDatasheet),
        'safetyDatasheet': ProductDocumentToJSON(value.safetyDatasheet),
        'brochures': value.brochures === undefined ? undefined : ((value.brochures as Array<any>).map(ProductDocumentToJSON)),
        'userManuals': value.userManuals === undefined ? undefined : ((value.userManuals as Array<any>).map(ProductDocumentToJSON)),
        'certificates': value.certificates === undefined ? undefined : ((value.certificates as Array<any>).map(ProductDocumentToJSON)),
        'productStock': value.productStock,
        'productWebshopStatus': value.productWebshopStatus,
        'productPartStatus': value.productPartStatus,
        'e6ProductId': value.e6ProductId,
        'ceMarking': value.ceMarking,
        'ceExpiryDate': value.ceExpiryDate,
        'contentUnit': value.contentUnit,
        'ean': value.ean,
        'mediqClassifications': value.mediqClassifications === undefined ? undefined : ((value.mediqClassifications as Array<any>).map(MediqClassificationToJSON)),
        'nonInventoryParts': value.nonInventoryParts === undefined ? undefined : ((value.nonInventoryParts as Array<any>).map(ProductNonInventoryPartToJSON)),
        'inPositiveList': value.inPositiveList,
        'limitPerOrder': value.limitPerOrder,
        'sailabCode': value.sailabCode,
        'regulationDirective': value.regulationDirective,
        'regulationProductClass': value.regulationProductClass,
        'regulationNotifiedBody': value.regulationNotifiedBody,
    };
}

